import { Masks, retrievePrecisionNumber } from 'shared/helpers';

const { number } = Masks;

export function calculateTotalNutrienteProdutos(produtos, nutriente) {
  const totalNutrientesPorProduto = produtos.map(
    (produto) => (produto[nutriente] / 100) * produto.quantidade,
  );
  return number(totalNutrientesPorProduto, {
    ed: retrievePrecisionNumber(nutriente),
  });
}

export function sortProducts(produtos) {
  return produtos.sort((a, b) => {
    if (a.user_id && !b.user_id) {
      return 1;
    }
    if (!a.user_id && b.user_id) {
      return -1;
    }
    const { nome: nomeA = '' } = a;
    const { nome: nomeB = '' } = b;

    return nomeA.toLowerCase().localeCompare(nomeB.toLowerCase());
  });
}


export const availableAttributes = {
  moedaPtBrHectare: 'moedaPtBrHectare',
  moedaPtBr: 'moedaPtBr',
};
